
export default (context, inject) => {
  function getText(textName) {
    return context.store.state.main.texts[textName] || '';
  }

  inject('t', getText);
};
